import { SelectInput } from "@src/components/ui-components/Selectors/SelectInput/SelectInput";
import { TextInput } from "@src/components/ui-components/Inputs/TextInput/TextInput";
import TypographyText from "@src/components/ui-components/TypographyText/TypographyText";
import { useProperties } from "@src/data-hooks/property/property.service";
import { getCurrentUser } from "@src/auth/getCurrentUser";

import { t } from "i18next";
import { useState } from "react";
import { ModalPopup } from "../ModalPopup/ModalPopup";

type DuplicateUnitPopupProps = {
  id: string;
  onConfirm: (popUpId: string, name: string, propertyID: string) => void;
  defaultName: string;
  defaultPropertyID: string;
};

export const DuplicateUnitPopup = ({ id, onConfirm, defaultName, defaultPropertyID }: DuplicateUnitPopupProps) => {
  const { user } = getCurrentUser();
  const { properties } = useProperties(user?.properties ?? []);

  const [name, setName] = useState(`${defaultName} (${t("main.copy")})`);
  const [propertyID, setPropertyID] = useState(defaultPropertyID);

  const confirm = () => {
    if (name.trim().length > 0 && propertyID) {
      onConfirm(id, name, propertyID);
    }
  };

  return (
    <ModalPopup
      id={id}
      title={t("propertyUnits.actions.duplicate.title", { unitName: defaultName })}
      onActionClicked={confirm}
      actionTitle={t("main.duplicate")}
      children={
        <div>
          <TypographyText marginBottom={16}>{t("propertyUnits.actions.duplicate.description", { unitName: defaultName })}</TypographyText>

          <TextInput label={t("main.name")} value={name} onChange={(text) => setName(text)} style={{ width: "100%" }} placeholder={t("main.name")} />

          <SelectInput
            isMulti={false}
            label={t("propertyUnits.actions.duplicate.propertyLabel")}
            options={properties.map((property) => ({ value: property.id, label: property.name ?? "" }))}
            value={propertyID}
            onChange={(selectedOption) => selectedOption && setPropertyID(selectedOption)}
            width="100%"
            marginTop={16}
          />
        </div>
      }
    />
  );
};
